export default __webpack_public_path__ + "static/media/960.82e3fe84.png";